/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 15:58:30
 * @LastEditors: xgx
 * @LastEditTime: 2022-10-21 14:23:48
 */
import req from "@/utils/request";

//  添加账号
export const list = (params) => req.post("/site-service/m/model/listPage", params);
export const updateState = (params) => req.post("/site-service/m/model/updateState", params);
export const up = (params) => req.post("/site-service/m/model/up", params);
export const down = (params) => req.post("/site-service/m/model/down", params);
export const getTemplateList = (params) => req.post("/site-service/m/site/template/list", params);
export const create = (params) => req.post("/site-service/m/model/create", params);
export const update = (params) => req.post("/site-service/m/model/update", params);
export const deleteOne = (params) => req.post("/site-service/m/model/delete", params);
export const createAndUpdate = (params) => req.post("/site-service/m/field/createAndUpdate", params);
export const selectListByModelId = (params) => req.post("/site-service/m/field/selectListByModelId", params);
